<template>
  <div class="chat-header">
    <div class="left" @click="goBack">
      <img src="../image/back.png" alt="back">
      返回
    </div>
    <div class="title">聊天窗口</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ChatHeader',
  data () {
    return {}
  },
  computed: {
    ...mapState('chat', ['currentConversation'])
  },
  methods: {
    goBack () {
      if (this.currentConversation && this.currentConversation.conversationID) {
        this.tim.setMessageRead({ conversationID: this.currentConversation.conversationID })
      }
      this.$store.commit('chat/updateProductInfo', false)
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.chat-header {
  width: 100%;
  height: .88rem;
  background: #2D2D3E;
  position: relative;

  .title {
    width: 100%;
    height: 100%;
    font-size: .32rem;
    color: #fff;
    text-align: center;
    line-height: .88rem;
  }

  .left {
    position: absolute;
    left: .3rem;
    top: .28rem;
    font-size: .24rem;
    color: #fff;

    img {
      width: .2rem;
      margin-right: .1rem;
    }
  }
}
</style>
